import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.features.deactivate-legal-entity.presenters.deactivate-legal-entity-presenter`

export default defineMessages({
  confirmModalTitle: {
    id: `${scope}.confirmModalTitle`,
    defaultMessage: 'Disable “{name}”?',
  },
  confirmModalBody: {
    id: `${scope}.confirmModalBody`,
    defaultMessage:
      'This entity won’t be available for new transactions. Its history stays intact, and you can enable it anytime.',
  },
  confirmModalConfirmButton: {
    id: `${scope}.confirmModalConfirmButton`,
    defaultMessage: 'Disable entity',
  },
  blockedModalTitle: {
    id: `${scope}.blockedModalTitle`,
    defaultMessage: 'Reassign locations before disabling',
  },
  blockedModalBody: {
    id: `${scope}.blockedModalBody`,
    defaultMessage:
      '{count, plural, one {# location is} other {# locations are}} still mapped to “{name}.” Move them to another entity or disable them first, then you can disable this entity.',
  },
  blockedModalConfirmButton: {
    id: `${scope}.blockedModalConfirmButton`,
    defaultMessage: 'Go to location settings',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  successToastTitle: {
    id: `${scope}.successToastTitle`,
    defaultMessage: '{name} moved to inactive',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'We couldn’t deactivate this entity',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage:
      'Something went wrong. Refresh the page and try again. If the problem continues, contact support.',
  },
})
